import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  FeatureDetails,
  SubmitApplicationInfo,
} from "./creatorApplicationTypes";
import { FileDetails } from "../scriptDetails/scriptDetailsSlice";

interface FormState {
  SubmitApplicationInfo: SubmitApplicationInfo;
}

interface UpdateFieldPayload {
  field: keyof SubmitApplicationInfo;
  value: any;
}
const initialState: FormState = {
  SubmitApplicationInfo: {
    // Basic Details
    fullName: "",
    gender: "",
    age: null,
    phoneNumber: "",
    videoLinks: [],
    country: "",
    city: "",
    state: "",
    address: "",
    brandsDontWantToWorkWith: "",
    skinTone: "",
    bodyType: "",
    hasRelativesInVideo: undefined,
    // Professional Details
    profileLink: "",
    experienceDescription: "",
    experience: "",
    previousVideos: [],
    topics: "",
    skills:'',
    availableHoursPerWeek: "",
    weekendAvailability: null,
    language: "",
    lastSalary: "",
    expectedPay: "",
    wardrobeStyle: [],
    backgroundStyle: [],

    // Video Equipment Details
    propsAvailable: "",
    greenScreenDetails: null,
    audioEquipmentDetails: { hasAudioEquipment: null, details: "" },
    cameraDetails: { hasCamera: null, details: "" },
    lightingDetails: { hasLighting: null, details: "" },
    additionalExperience: { hasAdditionalExperience: null, details: "" },
  },
};

const submitApplicationSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    updateField: (
      state: FormState,
      action: PayloadAction<UpdateFieldPayload>
    ) => {
      const { field, value } = action.payload;
      // @ts-ignore - we know the field exists in SignUpInfo
      state.SubmitApplicationInfo[field] = value;
    },


    resetApplicationForm: (state) => {
      return initialState;
    },
  },
});

export const { updateField, resetApplicationForm } =
  submitApplicationSlice.actions;

export default submitApplicationSlice.reducer;
